import * as amplitude from '@amplitude/analytics-browser';
import { environment } from '../../../../../environments/environment';

export const amplitudeInitializer = () => {
  return () => {
    if (!environment.amplitudeId) {
      return Promise.resolve();
    }

    amplitude.setTransport('beacon');
    return amplitude.init(environment.amplitudeId).promise;
  };
};
